'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _phaser = require('phaser');

var _phaser2 = _interopRequireDefault(_phaser);

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_Phaser$Sprite) {
  _inherits(_class, _Phaser$Sprite);

  function _class(game, x, y) {
    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, game, x, y, "sprites"));

    game.physics.arcade.enable(_this);
    _this.anchor.setTo(0.5, 1.0);
    _this.frameName = 'native_3';
    _this.dst = 32;
    return _this;
  }

  _createClass(_class, [{
    key: 'runTo',
    value: function runTo(x) {
      this.dst = x;
    }
  }, {
    key: 'update',
    value: function update() {
      var vx = 0.0;
      var dt = this.game.time.physicsElapsed;
      if (this.global.x < this.dst) vx = 25.0;else if (this.global.x > this.dst) vx = -25.0;else vx = 0.0;
      this.global.x = vx * dt + this.global.x;
    }
  }]);

  return _class;
}(_phaser2.default.Sprite);

exports.default = _class;


//////////////////
// WEBPACK FOOTER
// ./src/sprites/Native.js
// module id = 122
// module chunks = 0